export default "__VITE_ASSET__CJkv0DH0__"